import {Component, Input, OnInit, OnChanges} from '@angular/core';

@Component({
  selector: 'app-dev-kanban',
  templateUrl: 'kanban.component.html',
  styleUrls: ['kanban.component.css'],
})

export class KanbanComponent implements OnInit, OnChanges {
  newColumns: any[] = [];
  routerData = {};
  @Input() data: any[] =
    [{status: 10, descricao: 'tarefa 1'},
      {status: 10, descricao: 'tarefa 2'},
      {status: 20, descricao: 'tarefa 3'},
      {status: 10, descricao: 'tarefa 4'},
      {status: 10, descricao: 'tarefa 5'},
      {status: 10, descricao: 'tarefa 6'},
      {status: 30, descricao: 'tarefa 7'},
      {status: 20, descricao: 'tarefa 8'}
    ];

  @Input() columns: any[] = [
    {status: 10, caption: 'Pendente'},
    {status: 20, caption: 'Suspenso'},
    {status: 30, caption: 'Executando'},
    {status: 98, caption: 'Cancelado'},
    {status: 99, caption: 'Concluído'}
  ];

  @Input() columnValue = 'status';
  @Input() cardHeader = 'descricao';
  @Input() cardClass = 'white-cards';

  constructor() {
  }

  getRouterData(routerData) {
    this.routerData = routerData;
  }

  changeArray(columnValue): any {
    this.newColumns = this.columns.map((column) => {
      column['data'] = this.data.filter((data) => {
        return column[columnValue] === data[columnValue];
      });
      return column;
    });
  }

  ngOnInit() {
    this.changeArray(this.columnValue);
  }

  ngOnChanges() {
    this.changeArray(this.columnValue);
  }
}
